import React from 'react'
import Container from 'components/Container'
import { GuidanceWrapper } from './style'

const MonitoringGuidance = () => {
  return (
    <GuidanceWrapper>
      <Container>
        <iframe
          src="https://form.jotform.com/250993275234361"
          title="Monitoring Guidance Form"
          height="1680"
          width="100%"
          allowfullscreen
        ></iframe>
      </Container>
    </GuidanceWrapper>
  )
}

export default MonitoringGuidance
